<template>
  <div id="app">
    <div class="sip-calculator">
      <div class="row">
        <div class="col-lg-6 mb-4">
          <div class="card sip-border">
            <div class="card-body">
              <v-form @submit.prevent="submitForm">
                <div class="sip-input">
                  <label for="monthly-investment" class="label-spacing"
                    >My monthly investment</label
                  >
                  <span class="sip-group">
                    <div class="rupees-symbol">₹</div>
                    <input
                      type="text"
                      class="form-control"
                      v-model="formData.name"
                      outlined
                      id="monthly-investment"
                    />
                  </span>
                </div>
                <div class="sip-input">
                  <label for="time-returns" class="label-spacing"
                    >Expected returns</label
                  >
                  <span class="sip-group">
                    <button type="button" @click="decreaseReturns">-</button>
                    <input
                      class="form-control text-center"
                      type="text"
                      v-model="formData.returns"
                      outlined
                      id="time-returns"
                    />
                    <button type="button" @click="increaseReturns">+</button>
                  </span>
                </div>
                <div class="sip-input">
                  <label for="time-period" class="label-spacing"
                    >Number of years I plan to invest
                  </label>
                  <span class="sip-group">
                    <button type="button" @click="decreaseTimePeriod">-</button>
                    <input
                      type="text"
                      v-model="formData.time"
                      class="form-control text-center"
                      id="time-period"
                    />
                    <button type="button" @click="increaseTimePeriod">+</button>
                  </span>
                </div>
                <br />
                <button type="button" @click="submitForm()" class="sip-button">
                  Calculate
                </button>
              </v-form>
            </div>
          </div>
        </div>
        <div class="col-lg-6 mb-4">
          <div class="card second-card">
            <div class="sip-card">
              <label for="total-investment">Total investment</label>
              <input
                v-model="formattedTotalInvestment"
                id="total-investment"
                readonly
              />
            </div>
            <hr />
            <div class="sip-card">
              <label for="time-returns">Estimated gains</label>
              <input
                v-model="formattedTotalReturns"
                id="time-returns"
                readonly
              />
            </div>
            <hr />
            <div class="sip-card">
              <label for="total-returns">Final value</label>
              <input
                v-model="formattedTotalValue"
                id="total-returns"
                readonly
              />
            </div>
            <br />
            <div class="distribution-bar-container">
              <div class="distribution-label">
                <div class="box1"></div>
                <label for="distribution-bar">Invested Amount</label>
              </div>
              <div class="distribution-label">
                <div class="box2"></div>
                <label for="distribution-bar">Estimated Returns</label>
              </div>
              <br />
              <div class="distribution-bar">
                <div class="color-bar">
                  <div
                    class="bar-invest"
                    :style="{
                      width: investmentBarWidth,
                      backgroundColor: investmentBarColor,
                    }"
                  ></div>
                  <div
                    class="bar-invest"
                    :style="{ width: estimatedReturnsBarWidth }"
                  ></div>
                </div>
                <div class="bar-values">
                  <span>{{ formattedTotalInvestment }}</span>
                  <span>{{ formattedTotalReturns }}</span>
                </div>
              </div>
            </div>
            <i class="sip-disclaim"
              >Disclaimer: Results shown for illustrative purpose only and
              should not be construed as investment advice</i
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "CalculatorDesign",
  data() {
    return {
      formData: {
        name: 500,
        time: "1 Years",
        returns: "12 %",
        minValue: 0,
        maxValue: 100,
      },
      monthlyInvestment: "",
      timePeriod: "",
      totalValue: "6,165",
      totalDifference: "165",
      estimatedReturns: "",
      distributionValue: 75,
      formattedTotalInvestment: "",
      investmentBarWidth: "97.3%",
      estimatedReturnsBarWidth: "2.7%",
      investmentBarColor: "#205AA6",
    };
  },
  created() {
    this.formattedTotalInvestment = `₹ ${this.totalInvestment.toLocaleString(
      "en-IN"
    )}`;
  },
  computed: {
    totalInvestment: {
      get() {
        const monthlyInvestment = parseFloat(this.formData.name) || 0;
        const timePeriod = parseFloat(this.formData.time) || 0;
        return Math.round(monthlyInvestment * timePeriod * 12);
      },
    },
    formattedTotalValue() {
      return `₹ ${this.totalValue.toLocaleString("en-IN")}`;
    },
    formattedTotalReturns() {
      return `₹ ${this.totalDifference.toLocaleString("en-IN")}`;
    },
  },
  methods: {
    submitForm() {
      this.formattedTotalInvestment = `₹ ${this.totalInvestment.toLocaleString(
        "en-IN"
      )}`;
      this.calculateTotalValue();
    },
    increaseReturns() {
      const numericValue = parseFloat(this.formData.returns);
      if (numericValue > 4.5) {
        this.formData.returns = `${Math.min(numericValue + 0.5, 50)} %`;
      }
    },
    decreaseReturns() {
      const numericValue = parseFloat(this.formData.returns);
      if (numericValue <= 50.5) {
        this.formData.returns = `${Math.max(numericValue - 0.5, 5)} %`;
      }
    },
    calculateTotalValue() {
      const monthlyInvestment = parseFloat(this.formData.name);
      const annualReturns = parseFloat(this.formData.returns) / 100;
      const monthlyReturns = annualReturns / 12;
      const years = parseFloat(this.formData.time);
      const months = years * 12;
      let futureValue =
        monthlyInvestment *
        (((Math.pow(1 + monthlyReturns, months) - 1) / monthlyReturns) *
          (1 + monthlyReturns));
      this.totalValue = Math.round(futureValue) || 0;
      const totalInvestment = parseFloat(this.totalInvestment);
      const totalReturns = parseFloat(this.totalValue);
      this.totalDifference = Math.round(totalReturns - totalInvestment) || 0;
      this.estimatedReturns = Math.round(totalReturns - totalInvestment);
      this.investmentBarWidth = (totalInvestment / this.totalValue) * 100 + "%";
      this.estimatedReturnsBarWidth =
        (totalReturns / this.totalValue) * 100 + "%";
    },
    increaseTimePeriod() {
      const numericValue = parseInt(this.formData.time);
      if (numericValue < 50) {
        this.formData.time = `${numericValue + 1} Years`;
      }
    },
    decreaseTimePeriod() {
      const numericValue = parseInt(this.formData.time);
      if (numericValue > 1) {
        this.formData.time = `${numericValue - 1} Years`;
      }
    },
  },
};
</script>

<style scoped>
.sip-calculator .sip-input label {
  display: block;
  font-weight: bold;
  text-align: justify;
  font-size: 16px;
  color: #012e40 !important;
}

.sip-input input {
  text-align: justify;
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
  background: transparent;
}

.sip-calculator .sip-input button {
  background: transparent;
  border: none;
  color: #000000;
}

.sip-button {
  width: 100%;
  background: #00a3d9;
  color: white;
  height: 40px;
  border-radius: 5px;
}

.sip-group {
  display: flex;
  border: 1px solid #e5e5e5;
  margin: 0 0 10px;
  border-radius: 8px;
  -ms-flex-align: center;
  align-items: center;
  padding: 6px 12px;
  text-align: center;
}

.label-spacing {
  margin-bottom: 0.7rem;
}

.sip-border {
  border: none;
  outline: none;
  background: none;
}

.sip-card input {
  border: none;
  outline: none;
  background: none;
  flex: 1;
  text-align: right;
}

.sip-calculator {
  border: 1px solid #e5e5e5;
  border-radius: 10px;
  box-shadow: 0px 0px 30px 0px rgba(0, 0, 0, 0.1);
  padding: 1%;
}

.second-card {
  border: none !important;
  border-radius: 10px;
  background: #f8f9fa;
}

.second-card .sip-card {
  display: flex;
  align-items: center;
  padding: 10px;
}

.rupees-symbol {
  display: flex;
  font-size: 14px;
  color: #555;
}

.distribution-label {
  display: inline-flex;
  align-items: center;
  margin-bottom: 10px;
  margin-right: 5px;
}

.distribution-label .box1 {
  width: 30px;
  height: 10px;
  background-color: #205aa6;
  margin-right: 10px;
}

.distribution-label .box2 {
  width: 30px;
  height: 10px;
  background-color: #21d19f;
  margin-right: 10px;
}

.distribution-bar {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px;
}

.distribution-bar-container {
  text-align: center;
}

.color-bar {
  width: 100%;
  height: 20px;
  background-color: #21d19f;
  margin-bottom: 5px;
  position: relative;
}

.bar-invest {
  height: 100%;
  position: absolute;
  top: 0;
}

.bar-values {
  display: flex;
  justify-content: space-between;
  width: 100%;
  font-size: 12px;
}

.sip-disclaim {
  color: #918d99;
  font-size: 14px;
  margin-top: 5%;
  margin-bottom: 14px;
  padding: 4px;
}
</style>
